/*
 * @Date: 2022-07-04 17:19:47
 * @LastEditors: hanhuixian hanhuixian@lxrental.com
 * @desc: 页面Html框架（头部导航栏）
 */
export default {
  home: "Overview",

  about: "About Us",
  companyProfile: "Corporate Profile", // 关于我们/公司简介
  management: "Management", // 关于我们/管理层成员
  corporateGovernance: "Corporate Governance", // 关于我们/公司治理
  irNetwork: "IR Contacts", // 关于我们/投资者关系联络

  disclosure: "News & Events",
  circulars: "Announcements & Circulars", // 信息披露/公告与通函
  stockPrice: "Stock Information", // 信息披露/股价信息

  finance: "Financial Reports",
  quarter: "Interim Report", // 财务信息/中期报告
  year: "Annual Report", // 财务信息/年度报告

  esg: "ESG Report"
}